export default __webpack_public_path__ + "9f855913038cf1067dd81b50fea195bd.ttf";